import { ONBOARDING_LAST_STEP_KEY } from '@/constants/onboarding'

export function setLastCompletedStep(step) {
  sessionStorage.setItem(ONBOARDING_LAST_STEP_KEY, String(step))
}

export function getLastCompletedStep() {
  const raw = sessionStorage.getItem(ONBOARDING_LAST_STEP_KEY)
  const n = Number(raw)
  return Number.isFinite(n) && n >= 1 && n <= 7 ? n : 0
}

/** Marqueur interne dans lifestyle JSONB (non exposé au matching). */
export const ONBOARDING_FAMILY_FLAG = '_onboarding_family'

/**
 * Détermine la prochaine étape à afficher (1–7) ou 8 si onboarding terminé.
 * @param {object|null} profile
 * @param {boolean} cartaAccepted — Carta de Convivencia firmada (convivencia_acceptances)
 */
export function resolveOnboardingStep(profile, cartaAccepted = false) {
  if (!profile?.name?.trim()) return 1
  if (!profile.lifestyle?.[ONBOARDING_FAMILY_FLAG]) return 2
  if (profile.work_schedule == null) return 3
  if (profile.lifestyle?.cleanliness == null) return 4
  if (!profile.preferred_zones?.length) return 5
  if (!profile.verification_method) return 6
  if (!profile.profile_completed || !cartaAccepted) return 7
  return 8
}

export function onboardingRouteForStep(step) {
  if (step >= 8) return { name: 'my-profile' }
  if (step < 1) return { name: 'onboarding-step-1' }
  return { name: `onboarding-step-${step}` }
}
